import {
  SafeHtmlContent,
  Text,
  Button,
  Popup
} from '@yes.technology/react-toolkit'
import { useState } from 'react'
import { Container, Content, Image } from './WelcomeModal.styles'
import { WelcomeModalProps } from './WelcomeModal.types'
import { useParams } from 'react-router-dom'

export const DISMISSED_WELCOME_SITEMODELS_KEY = 'dismissed-welcome-sitemodels'

const getDismissedWelcomeSitemodels = (): string[] => {
  try {
    const ids = JSON.parse(
      window.localStorage.getItem(DISMISSED_WELCOME_SITEMODELS_KEY) || '[]'
    )

    return Array.isArray(ids) && ids.every((id) => typeof id === 'string')
      ? ids
      : []
  } catch (e) {}

  return []
}

const appendDismissedWelcomeSitemodel = (sitemodelUuid: string) => {
  const previousIds = getDismissedWelcomeSitemodels()
  const newIds = [...previousIds, sitemodelUuid]
  window.localStorage.setItem(
    DISMISSED_WELCOME_SITEMODELS_KEY,
    JSON.stringify(newIds)
  )
}

type UseWelcomeModalProps = {
  sitemodelUuid: string
}

const useWelcomeModal = ({ sitemodelUuid }: UseWelcomeModalProps) => {
  const [isOpen, setIsOpen] = useState(
    () => !getDismissedWelcomeSitemodels().includes(sitemodelUuid)
  )

  const close = () => {
    appendDismissedWelcomeSitemodel(sitemodelUuid)
    setIsOpen(false)
  }

  return {
    isOpen,
    close
  }
}

const WelcomeModal = ({
  props: {
    title,
    image,
    content,
    main_button: mainButton,
    dismiss_button: dismissButton
  }
}: WelcomeModalProps) => {
  const { sitemodelUuid = '' } = useParams<{ sitemodelUuid: string }>()
  const { isOpen, close } = useWelcomeModal({ sitemodelUuid })

  return (
    <Popup {...{ isOpen }} onClose={close} heightClass='regular'>
      <Container>
        <Text variant='label-required-04'>{title}</Text>
        <Image src={image.url} alt={image.alt || ''} />
        <Content>
          <SafeHtmlContent html={content} />
        </Content>
        <a
          href={mainButton.url}
          target={mainButton.target}
          rel={
            mainButton.target === '_blank' ? 'noopener noreferrer' : undefined
          }
          onClick={close}
          tabIndex={-1}
        >
          <Button>{mainButton.label}</Button>
        </a>
        <Button onClick={close} variant='secondary'>
          {dismissButton.label}
        </Button>
      </Container>
    </Popup>
  )
}

export default WelcomeModal
